import { useCallback } from 'react'

import { MedconnectAgentConfig } from '@/core/models/account.model'
import { updateMyProfile } from '@/redux/reducers/auth.reducer'
import { useAppDispatch } from '@/redux/rootReducer'

export function useChangeToolConfig() {
  const dispatch = useAppDispatch()

  return useCallback(
    (newConfig: MedconnectAgentConfig) => {
      dispatch(
        updateMyProfile({
          medconnectAgentConfig: newConfig,
        })
      )
    },
    [dispatch]
  )
}
